import header from "./front-neubau-doppelhaushaelfte.webp";
import section1 from "./türschloss.jpg";
import section2 from "./wohnzimmer.jpg";
import section3 from "./visualisierung-eines-grundrisses.webp";
import section4 from "./visualisierung-eines-hauses.jpg";
import section5 from "./grundrisse-auf-papier.webp";

export { header, section1, section2, section3, section4, section5 };
